import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../../components/AppIcon';

export const AppItemMobile = ({
  onAppRemove,
  app: {
    ref_no,
    big_icon_url,
    icon_url,
    store,
    name,
  },
}) => (
  <div
    className="app-selection-app-box"
    onClick={() => onAppRemove(ref_no)}
  >
    <span className="app-selection-app-remove" />
    <AppIcon
      url={big_icon_url || icon_url}
      store={store}
      size={48}
      alt={name}
      containerClasses="app-selection-app-item"
      hideHtmlTitle
    />
  </div>
);

AppItemMobile.propTypes = {
  onAppRemove: T.func.isRequired,
  app: T.shape({
    ref_no: T.oneOfType([T.string, T.number]),
    big_icon_url: T.string,
    icon_url: T.string,
    store: T.string,
    name: T.string,
  }).isRequired,
};

export const AppPlaceholderMobile = ({ onPlaceholderClick, showSelected }) => {
  const color = '#228BF4';

  const handlePlaceholderClick = () => {
    onPlaceholderClick();
  };

  return (
    <div
      onClick={handlePlaceholderClick}
      className={cx('app-selection-app-box app-selection-app-placeholder',
      {
        'app-selection-app-placeholder-taped': showSelected,
      })}
    >
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M24 17.51C24.2761 17.51 24.5 17.7339 24.5 18.01V23.5H30C30.2761 23.5 30.5 23.7239 30.5 24C30.5 24.2762 30.2761 24.5 30 24.5H24.5V30.01C24.5 30.2862 24.2761 30.51 24 30.51C23.7239 30.51 23.5 30.2862 23.5 30.01V24.5H18C17.7239 24.5 17.5 24.2762 17.5 24C17.5 23.7239 17.7239 23.5 18 23.5H23.5V18.01C23.5 17.7339 23.7239 17.51 24 17.51Z" fill={color} />
        <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" stroke={color} strokeDasharray="2 2" />
      </svg>
    </div>
  );
};

AppPlaceholderMobile.propTypes = {
  onPlaceholderClick: T.func.isRequired,
  showSelected: T.bool,
};
